import { ICON__eye_slash_solid, ICON__eye_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_page_search from '@/locales/keys/i18n_page_search.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { FN_USER_SETTINGS__update } from '@/utils/utils_client';
import { useTranslation } from 'react-i18next';

export function SButtonHideUnusedTokens() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SEARCH);

  const { user_settings } = use_slice_user(['user_settings']);

  async function onClick() {
    const settingsNew = user_settings.clone({ search_prompt_hide_unused_tokens: !user_settings.search_prompt_hide_unused_tokens });

    await FN_USER_SETTINGS__update(settingsNew);
  }

  return (
    <UI_PRIMITIVE__tooltip
      tooltip_title={
        user_settings.search_prompt_hide_unused_tokens
          ? t(i18n_page_search.sidebar.prompt_component.button.hide_unused_values.tooltip_show)
          : t(i18n_page_search.sidebar.prompt_component.button.hide_unused_values.tooltip_hide)
      }
      side="right"
    >
      <UI_PRIMITIVE__button_with_icon_animated
        className="w-11"
        size="square-10"
        variant="no-border-on-bar"
        iconClassNameBase="!text-component-item-foreground !w-5 !h-5"
        iconClassNameHovered="!text-bar-foreground"
        {...{ onClick }}
        renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        Icon={user_settings.search_prompt_hide_unused_tokens ? ICON__eye_solid : ICON__eye_slash_solid}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
